import React from 'react';
import PropTypes from 'prop-types';
import ConfigCard from './ConfigCard';
import { OrderedChipList } from './_PdiHelpers';

// All sections the storefront knows how to render on the product page. Each
// section is either IN USE (chip in the ordered list) or AVAILABLE.
const DEFAULT_BLOCKS = [
    { key: 'header',          i18nKey: 'cfg_pdi_layout_block_header',          fallback: 'Header',           used: true  },
    { key: 'sizeSelector',    i18nKey: 'cfg_pdi_layout_block_size_selector',   fallback: 'Size selector',    used: true  },
    { key: 'addToCart',       i18nKey: 'cfg_pdi_layout_block_add_to_cart',     fallback: 'Add to cart',      used: true  },
    { key: 'stockByLocation', i18nKey: 'cfg_pdi_layout_block_stock_location',  fallback: 'Stock by location',used: true  },
    { key: 'variants',        i18nKey: 'cfg_pdi_layout_block_variants',        fallback: 'Variants',         used: true  },
    { key: 'relatedProducts', i18nKey: 'cfg_pdi_layout_block_related',         fallback: 'Related products', used: true  },
    { key: 'productInfo',     i18nKey: 'cfg_pdi_layout_block_product_info',    fallback: 'Product info',     used: true  },
    { key: 'extraText',       i18nKey: 'cfg_pdi_layout_block_extra_text',      fallback: 'Extra text',       used: true  },
    { key: 'washInstructions',i18nKey: 'cfg_pdi_layout_block_wash',            fallback: 'Wash instructions',used: false },
];

const PageLayoutCard = ({ value = {}, onChange, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const blocks = value.blocks || {};

    const items = DEFAULT_BLOCKS.map(b => ({
        key:   b.key,
        label: tr(b.i18nKey, b.fallback),
        used:  blocks[b.key]?.used !== undefined ? blocks[b.key].used : b.used,
    }));

    const setUsed = (k, v) => onChange && onChange('blocks', { ...blocks, [k]: { used: v } });

    return (
        <ConfigCard
            title={tr('cfg_pdi_layout_title', 'Page layout')}
            description={tr('cfg_pdi_layout_desc', 'Which sections appear on the product page and in what order. Drag chips to reorder, or click an available field below to add it.')}
            theme={theme}
        >
            <OrderedChipList
                orderedLabel={tr('cfg_pdi_layout_used',      'Sections used (in order)')}
                availableLabel={tr('cfg_pdi_layout_available','Available (click to add)')}
                items={items}
                setUsed={setUsed}
            />
        </ConfigCard>
    );
};

PageLayoutCard.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default PageLayoutCard;
